import { Arrange, Container } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  EXP_EMBED_END_OF_VIDEO_NUDGES,
  ROLLOUT_VIDEO_PLAYER_END_SCREEN,
} from 'constants/featureFlag';
import { selectCtaEnabled } from 'selectors/shareVideo';
import {
  selectHasEnded,
  selectHasStarted,
  selectShowCta,
} from 'selectors/videoPlayer';

import { useFlagIsActivated } from 'hooks/featureFlag';

import EmbedActionButtons from './action-buttons';
import CtaButton from './cta-button-rework';
import EmbedTitleAuthor from './embed-title-author';

import styles from './styles.module.less';

const EmbedTopBar = () => {
  const hasStarted = useSelector(selectHasStarted);
  const showCta = useSelector(selectShowCta);
  const ctaEnabled = useSelector(selectCtaEnabled);
  const hasEnded = useSelector(selectHasEnded);
  const experimentEndOfVideoNudges = useSelector(
    state => state.feature_flags?.[EXP_EMBED_END_OF_VIDEO_NUDGES]
  );
  const experimentEndOfVideoNudgesLoading = hasEnded
    ? experimentEndOfVideoNudges?.fetching ||
      !experimentEndOfVideoNudges?.fetched
    : false;
  const experimentEndOfVideoNudgesValue = experimentEndOfVideoNudges?.value;

  const endOfVideoNudgesOn =
    experimentEndOfVideoNudgesValue === 'variant-1' ||
    experimentEndOfVideoNudgesValue === 'variant-2';

  const newEndScreenFeature = useFlagIsActivated({
    flag: ROLLOUT_VIDEO_PLAYER_END_SCREEN,
    activationValues: ['variant'],
  });

  const showFullBar = !hasStarted || (hasEnded && newEndScreenFeature);

  const hideFullBar =
    !ctaEnabled && !experimentEndOfVideoNudgesLoading && endOfVideoNudgesOn;

  return (
    <div className={classnames(styles.embedTopSection, 'theme-dark')}>
      <Container
        padding={{ default: 'small', small: 'medium' }}
        position="absolute"
        top={0}
        width="100%"
      >
        <Arrange justifyContent="space-between" gap="small" alignItems="start">
          <Container minWidth={0}>
            {showFullBar && !hideFullBar && (
              <EmbedTitleAuthor
                hideDurationAndViewCount={
                  !experimentEndOfVideoNudgesLoading && endOfVideoNudgesOn
                }
              />
            )}
          </Container>
          <Arrange gap="small" minWidth="max-content">
            {ctaEnabled && (showCta || endOfVideoNudgesOn) && <CtaButton />}
            {!experimentEndOfVideoNudgesLoading && !endOfVideoNudgesOn && (
              <EmbedActionButtons />
            )}
          </Arrange>
        </Arrange>
      </Container>
    </div>
  );
};

export default EmbedTopBar;
